<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer ml-1" data-toggle="modal" :data-target="'#dueDateModal' + task.id" @click="disableTitleEditing()">date_range</i>
    <div class="modal fade" :id="'dueDateModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">When?</h5>
          </div>
          <div class="modal-body">
            <div class="mt-2 alert alert-light pointer" @click="setInbox()">
              <i :class="iconStyle(this.$t('tier1.inbox.color'))">{{ $t("tier1.inbox.icon") }}</i>
              <span class='h3'>{{ $t("tier1.inbox.name") }}</span>
            </div>    
            <div class="mt-2 alert alert-light pointer" @click="setTier1('essentials')">
              <i :class="iconStyle(this.$t('tier1.essentials.color'))">{{ $t("tier1.essentials.icon") }}</i>
              <span class='h3'>{{ $t("tier1.essentials.name") }}</span>
            </div>  
            <div class="mt-2 alert alert-light pointer" @click="setTier1('project_essentials')">
              <i :class="iconStyle(this.$t('tier1.project_essentials.color'))">{{ $t("tier1.project_essentials.icon") }}</i>
              <span class='h3'>{{ $t("tier1.project_essentials.name") }}</span>
            </div>                          
            <div class="mt-2 alert alert-light pointer" @click="setTier1('someday')">
              <i :class="iconStyle(this.$t('tier1.someday.color'))">{{ $t("tier1.someday.icon") }}</i>
              <span class='h3'>{{ $t("tier1.someday.name") }}</span>
            </div>
            <div class="mt-2 alert alert-light pointer" @click="setTier1('waiting')">
              <i :class="iconStyle(this.$t('tier1.waiting.color'))">{{ $t("tier1.waiting.icon") }}</i>
              <span class='h3'>{{ $t("tier1.waiting.name") }}</span>
            </div>
            <div class="mt-2 alert alert-light pointer" @click="setTier1('in_process')">
              <i :class="iconStyle(this.$t('tier1.in_process.color'))">{{ $t("tier1.in_process.icon") }}</i>
              <span class='h3'>{{ $t("tier1.in_process.name") }}</span>
            </div> 
                       
            <span @click="confirmDateChange">
              <v-date-picker
                :min-date='new Date()'
                v-model="changedDate"
                mode="single"
                is-inline
                is-expanded />
            </span>
            <div class="alert alert-light pointer" @click="setToday">
              <i :class="iconStyle(this.$t('tier1.today.color'))">{{ $t("tier1.today.icon") }}</i>
              <span class='h4'>{{ $t("tier1.today.name") }}</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button v-if="task.due_date || task.tier1 " type="button" class="btn btn-primary" @click="clearDueDate">Remove Due Date</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import api from "api";
import { setupCalendar, Calendar, DatePicker} from 'v-calendar'

export default {
  components: {
    'v-date-picker': DatePicker
  },
  data() {
    return {
      date: (this.task.due_date ? new Date(this.task.due_date.split('-')) : null),
      tier1: this.task.tier1,
      changedDate: (this.task.due_date ? new Date(this.task.due_date.split('-')) : null),
      confirmChange: true,
      allowDateChange: false
    };
  },
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    iconStyle(tier1Color){
      if(tier1Color){
        return "material-icons pointer text-" + tier1Color
      } else {
        return "material-icons pointer"
      }
    },
    saveDate() {
      api.updateTask(this.task.id, { due_date: this.date, tier1: this.tier1 }).then(response => {
        this.closeModal()
      });
    },
    saveTier1() {
      var store = this.$store
      var taskId = this.task.id
      var fromGroupName = 'tier1' + this.task.tier1
      var toGroupName = 'tier1' + this.tier1
      var payload = { tier1: this.tier1 }

      if(this.task.project_id === null){
        payload['project_id'] = 0
      }

      api.updateTask(taskId, payload).then(response => {
        this.updateSorting(taskId, fromGroupName, toGroupName, store)
        this.closeModal()
      });
    },
    setToday(){
      if(confirm('Are you sure you want to move this item to Today?')){
        var store = this.$store
        this.date = new Date()
        this.changedDate = new Date()
        store.commit('addToSortedGroup', {
          taskId: this.task.id,
          groupName: 'today'
        })

        this.$router.push({name: 'today' })  
        this.saveDate()
      } else {
        this.changedDate = this.date
        this.closeModal()
      }
    },
    setTier1(tier1){
      if(confirm('Are you sure you want to move this item to ' + this.$t("tier1." + tier1 + ".name") + '?')){
        this.tier1 = tier1
        this.saveTier1()
        this.$router.push({name: tier1 }) 
      } else {
        this.closeModal()
      }
    },
    setInbox(){
      var taskId = this.task.id

      if(confirm('Are you sure you want to move this item to ' + this.$t("tier1.inbox.name") + '?')){
        var payload = { tier1: null, project_id: null, sort: -1 }

        api.updateTask(taskId, payload).then(response => {
          this.closeModal()
          this.$router.push({name: 'inbox' }) 
        });
      } else {
        this.closeModal()
      }
    },
    clearDueDate() {
      if(confirm('Are you sure you want to remove the due date for this item?')){
        var store = this.$store
        var router = this.$router
        var task = this.task
        var tier1 = task.tier1
        this.date = null;
        this.changedDate = null;
        api.updateTask(this.task.id, { due_date: null, tier1: null }).then(response => {
          store.commit('removeFromSortedGroup', {
            taskId: task.id,
            groupName: 'today'
          })

          store.commit('removeFromSortedGroup', {
            taskId: task.id,
            groupName: 'tier1' + tier1
          })
          this.closeModal()
          router.push({ name: 'todo', params: { task_id: task.id } })
        });
      } else {
        this.changedDate = this.date
        this.closeModal()
      }
    },
    closeModal(){
      $('#dueDateModal' + this.task.id).modal('hide');
      $('body').removeClass('modal-open');
      $(".modal-backdrop").hide();
    },
    confirmDateChange(event){
      if(event.composedPath().filter(e => e.className === 'vc-grid-container vc-weeks').length > 0) {
        if(confirm('Are you sure you want to change the due date for this item?')){
          this.date = this.changedDate
          // this.tier1 = null
          this.$router.push({name: 'calendar' })               
          this.saveDate()
        } else {
          this.changedDate = this.date
        }
        this.closeModal()
      }
    },
    disableTitleEditing(){
      this.$parent.disableTitleEditing();
    },
    updateSorting(taskId, fromGroupName, toGroupName, store){
      store.commit('removeFromSortedGroup', {
        taskId: taskId,
        groupName: fromGroupName
      })

      store.commit('addToSortedGroup', {
        taskId: taskId,
        groupName: toGroupName
      })
    }
  }
}
</script>
